import Favorite from './Favorite';

export default Favorite;
